import { List } from 'immutable';
import { Inline, Value } from 'slate';
import { Editor } from 'slate-react';

import { INLINE_TYPES } from './constants';
import {
	getLinkType,
	getGotoPageAction,
	getPageFromGotoPageAction,
} from '../../../../containers/Editor/utils/helpers';
import { LinkType } from '../../../../containers/Editor/constants';

interface LinkData {
	href: string;
	action?: string;
}

export const getLinks = (inlines: List<Inline>) => (
	inlines.filter(({ type, text }: Inline) => type === INLINE_TYPES.a && !!text)
);

export const getLinkHref = (inlines: List<Inline>): string => {
	const links = getLinks(inlines);

	if (!links.size) {
		return '';
	}

	const { data } = links.first();
	const type = getLinkType(data.get('href'));
	const href = type === LinkType.url
		? data.get('href')
		: getPageFromGotoPageAction(data.get('action'));

	return href;
};

const getLinkData = (href: string): LinkData => {
	const type = getLinkType(href);
	return {
		href: type === LinkType.url ? href : 'javascript:void(0)',
		action: type === LinkType.gotoPage ? getGotoPageAction(href) : undefined,
	};
};

const createLink = (editor: Editor, href: string): void => {
	editor.wrapInline({
		type: INLINE_TYPES.a,
		data: getLinkData(href),
	});
};

const removeLink = (editor: Editor): void => {
	editor.unwrapInline(INLINE_TYPES.a);
};

export const updateLink = (editor: Editor, editorValue: Value, href: string): void => {
	const { inlines, selection } = editorValue;
	const links = getLinks(inlines);

	if (!links.size) {
		if (selection.isExpanded && href) {
			createLink(editor, href);
		}
	} else {
		links.forEach(({ key }: Inline) => {
			if (href) {
				editor.setNodeByKey(key, {
					type: INLINE_TYPES.a,
					data: getLinkData(href),
				});
			} else {
				removeLink(editor);
			}
		});
	}
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/RichTextEditor/helpers/links.ts